import { Textfield } from "@design-system/Inputs/Textfield";
import { Modal } from "@design-system/Modal";
import { ChangeEvent, type FC } from "react";
import { useEditSupplierModalTranslations } from "./i18n";

export const EditSupplierModal: FC<{
    open: boolean;
    onOpenChange: (open: boolean) => void;
    supplierName: string;
    onSupplierNameChange: (name: string) => void;
    onSave: () => void;
}> = ({ open, onOpenChange, supplierName, onSupplierNameChange, onSave }) => {
    const handleNameChange = (event: ChangeEvent<HTMLInputElement>) => {
        onSupplierNameChange(event.target.value);
    };

    const { t, keys } = useEditSupplierModalTranslations();

    const handleSave = () => {
        if (supplierName) {
            onOpenChange(false);
            onSave();
        }
    };

    return (
        <Modal open={open} onOpenChange={onOpenChange}>
            <Modal.Overlay scrollable>
                <Modal.Content>
                    <Modal.Header withClose>
                        <Modal.Title>{t(keys.modal_title)}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Textfield
                            placeholder={t(keys.supplier_name_placeholder)}
                            value={supplierName}
                            error={
                                supplierName
                                    ? undefined
                                    : t(keys.supplier_name_error)
                            }
                            onChange={handleNameChange}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Modal.CancelCTA>{t(keys.cancel_btn)}</Modal.CancelCTA>
                        <Modal.ConfirmCTA preventClose onClick={handleSave}>
                            {t(keys.save_btn)}
                        </Modal.ConfirmCTA>
                    </Modal.Footer>
                </Modal.Content>
            </Modal.Overlay>
        </Modal>
    );
};
